/*
*###############################################################################
*Module Name                   : VoucherBarcodePrintDetails.js                   #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               :  W M Shanika Chamodi                          #
*Date                          : Thursday, January 12th 2022, 9:53:47 am        #
*Copyright © 2022 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/
import React, { useState, useEffect } from "react"
import { Row, Col } from "reactstrap"
import DPTextBoxforgrid from "../../../framework/components/DPTextBoxforgrid"
import DPAlert from "../../../framework/widgets/DPAlert"
import ReactPaginate from "react-paginate"
const VoucherBarcodePrintDetails = ({
  DataRow,
  RemoveRow,
  BookChange,
  SupplierCode,
  blDiasableGrid,
  handleClearStatus
}) => {

  const [currentPage, setCurrentPage] = useState(1)
  const [postsPerPage] = useState(20)

  useEffect(() => {
    setCurrentPage(1)
  }, [handleClearStatus])

  const handlePageClick = (event) => {
    setCurrentPage(event.selected + 1);
  };


  const indexOfLastPost = currentPage * postsPerPage
  const indexOfFirstPost = indexOfLastPost - postsPerPage
  const currentPosts = DataRow.slice(indexOfFirstPost, indexOfLastPost) //current posts list 


  return (
    <React.Fragment>
      <Row>
        <Col sm={12} md={12} className="mb-12-sm">
          <table style={{ fontSize: "11px" }} id={"VoucherPODet"}>
            <thead className="table-light">
              <tr>
                <th>#</th>
                <th style={{ textAlign: "left" }}>Voucher No</th>
                <th style={{ textAlign: "left" }}>Voucher Description </th>
                <th style={{ textAlign: "left" }}>GRN Date</th>
                <th style={{ textAlign: "left" }}>Valid Days</th>
                <th style={{ textAlign: "right" }}>Qty</th>
                <th style={{ textAlign: "right" }}>Selling Price</th>
                <th style={{ textAlign: "right" }}>Reference</th>
              </tr>
            </thead>
            <tbody>
              {(currentPosts || []).map((formRow, key) => (
                <TableRow
                  FormRow={formRow}
                  Key={key}
                  RemoveRow={RemoveRow}
                  Disabled={blDiasableGrid}
                  BookChange={BookChange}
                  SupplierCode={SupplierCode}
                  indexOfFirstPost={indexOfFirstPost}
                />
              ))}
            </tbody>

          </table>
        </Col>
      </Row>
      <Row>
        <Col md="12">
          <ReactPaginate
            previousLabel={'previous'}
            nextLabel={'next'}
            breakLabel={'...'}
            pageClassName="page-item"
            pageLinkClassName="page-link"
            previousClassName="page-item"
            previousLinkClassName="page-link"
            nextClassName="page-item"
            nextLinkClassName="page-link"
            breakClassName="page-item"
            breakLinkClassName="page-link"
            pageCount={Math.ceil(DataRow.length / postsPerPage)}
            pageRangeDisplayed={5}
            onPageChange={handlePageClick}
            forcePage={currentPage - 1}
            renderOnZeroPageCount={null}
            activeClassName={'active'}
            activeLinkClassName={'page-link'}
            containerClassName={'pagination justify-content-end pagination-sm'}
          />
        </Col>
      </Row>
    </React.Fragment>
  )
}
export default VoucherBarcodePrintDetails

const TableRow = ({ FormRow, Key, indexOfFirstPost }) => {

  const [sweetAlertShow, setsweetAlertShow] = useState(false)
  const [AlertDescription, setAlertDescription] = useState(false)

  return (
    <tr key={FormRow.id}>
      <td>
        {" "}
        <Row className="mb-0">
          <Col md="12">{indexOfFirstPost + Key + 1}</Col>
        </Row>
      </td>
      <td style={{ width: "150px" }}>
        <Row className="mb-0">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="text"
              maxLength="3"
              id={"txtcode" + Key}
              value={FormRow.code}
              disabled={true}
            />
          </Col>
        </Row>
      </td>
      <td style={{ width: "250px" }}>
        <Row className="mb-0">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="text"
              maxLength="8"
              id={"txtdesc" + Key}
              value={FormRow.desc}
              disabled={true}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td style={{ width: "150px" }}>
        <Row className="mb-0">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="text"
              disabled={true}
              id={"txtGRNDate" + Key}
              value={FormRow.grnDate}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td style={{ width: "150px" }}>
        <Row className="mb-0">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="text"
              id={"txtReference" + Key}
              value={FormRow.reference}
              disabled={true}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td style={{ width: "150px" }}>
        <Row className="mb-0">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="text"
              id={"txtQty" + Key}
              value={FormRow.qty}
              disabled={true}
              textAlign="right"
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>

      <td style={{ width: "150px" }}>
        <Row className="mb-0">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="text"
              textAlign="right"
              id={"txtSellingPrice" + Key}
              value={FormRow.sellingPrice}
              disabled={true}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td style={{ width: "150px" }}>
        <Row className="mb-0">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              textType="text"
              id={"reference" + Key}
              value={FormRow.reference}
              disabled={true}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>

      <DPAlert
        confirm_both={sweetAlertShow}
        title={"Voucher Transfer In Note !"}
        description={AlertDescription}
        showCancel={false}
        btnColor={"success"}
        cancelColor={"danger"}
        onConfirm={() => {
          setsweetAlertShow(false)
        }}
        btnYes={"OK"}
      />
    </tr>
  )
}
